import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
  selector: 'app-violations',
  templateUrl: './violations.component.html',
  styleUrls: ['./violations.component.scss']
})

export class ViolationsComponent implements OnInit {

  empRole: string = '';
  id: string;
  mode: string;
  sDate: any;

  constructor(
    private route: ActivatedRoute,
    private storageConfiguration: StorageConfiguration
  ) { }

  ngOnInit() {
   
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.mode = params['mode'];
      this.sDate = params['date'];
    });

    if (this.mode == 'review') {
      this.empRole = 'Employee';
    } else {
      this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    }
  }

}
